<template>
  <FormPart
      :Item="TicketItem"
      :setItemForm="setItemForm"
      :submitData="submitData"
      @onSuccess="onSuccess"
      @onFail="onFail"
  >
    <template
        v-slot:default="{
          errors,
          ItemForm,
          submit
        }"
    >
      <v-row>
        <v-col
            cols="12"
        >
          <SuggestUsersRole
              v-model="ItemForm.users"
              :error-messages="errors.users"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Užívatelia"
              :multiple="true"
              :clearable="true"
              role="ROLE_WORKER"
              :createButton="$store.getters['auth/isLogged'] && $store.getters['auth/hasRole']('ROLE_MASTER')"
              @change="submit"
          />
        </v-col>

        <v-col
            :key="TicketItem.users.length + 'leader'"
            cols="12"
        >
          <SuggestUsersRoleTicketItem
              v-model="ItemForm.Leader"
              :error-messages="errors.Leader"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Vedúci"
              :clearable="true"
              role="ROLE_LEADER"
              :ticketItemId="TicketItem.id"
              :createButton="$store.getters['auth/isLogged'] && $store.getters['auth/hasRole']('ROLE_MASTER')"
              @change="submit"
          />
        </v-col>

        <v-col
            :key="TicketItem.users.length + 'worker'"
            cols="12"
        >
          <SuggestUsersRoleTicketItem
              v-model="ItemForm.Worker"
              :error-messages="errors.Worker"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Pracovník"
              :clearable="true"
              role="ROLE_WORKER"
              :ticketItemId="TicketItem.id"
              :createButton="$store.getters['auth/isLogged'] && $store.getters['auth/hasRole']('ROLE_MASTER')"
              @change="submit"
          />
        </v-col>
      </v-row>
    </template>
  </FormPart>
</template>

<script>
  import TicketItems from '@/services/ticket-items'

  import FormPart from '@/components/_Part/Form'

  import SuggestUsersRole from '@/components/Users/SuggestRole'
  import SuggestUsersRoleTicketItem from '@/components/Users/SuggestRoleTicketItem'

  export default {
    name: 'FormAssignment',
    props: [
      'TicketItem'
    ],
    emits: [
      'refresh'
    ],
    components: {
      FormPart,
      SuggestUsersRole,
      SuggestUsersRoleTicketItem
    },
    methods: {
      setItemForm(Item) {
        return {
          users: Item.users.map((_User) => _User.id),
          Leader: Item.Leader?.id,
          Worker: Item.Worker?.id
        }
      },
      submitData(ItemForm) {
        return TicketItems
          .updateAssignment({
            id: this.TicketItem.id,
            data: ItemForm
          })
      },
      onSuccess() {
        this.$emit('refresh')
      },
      onFail() {
        this.$router.push('/ticket/' + this.TicketItem.Ticket.id)
      }
    }
  }
</script>
